import PropTypes from 'prop-types';
import styled from 'styled-components';

//helper
import { screen } from '@/helpers/screen';

//components
import { FlexColumn, FlexRowWrap } from '@/components/Grid/Flex';

const LinkSectionWrapper = styled(FlexColumn)`
  min-width: 150px;
  margin: 20px 2px;

  font-size: 12px;

  ${screen.md} {
    min-width: 120px;

    font-size: 12px;
  }

  ${screen.lg} {
    min-width: 148px;

    font-size: 14px;
  }

  ${screen.xxlg} {
    min-width: 150px;

    font-size: 16px;
  }
`;

const LinkSectionTitle = styled.span`
  margin: 8px 0 16px;

  font-weight: bold;
  text-transform: uppercase;
`;

const Link = styled.a`
  margin: 10px 0;

  color: #acb2b6;
`;

const IconLink = styled.a`
  margin: 11px;

  color: inherit;

  ${screen.md} {
    margin: 6px;
  }

  ${screen.lg} {
    margin: 12px;
  }
`;

const IconGridWrapper = styled(FlexRowWrap)`
  max-width: 168px;
  margin: -11px -11px 0;

  ${screen.md} {
    max-width: 248px;
    margin: 0 -6px;
  }

  ${screen.lg} {
    max-width: 294px;
    margin: 0 -12px;
  }
`;

const LinkSection = ({ title, children, ...other }) => (
  <LinkSectionWrapper {...other}>
    {title && <LinkSectionTitle>{title}</LinkSectionTitle>}
    {children}
  </LinkSectionWrapper>
);

const SocialLinkSection = styled(LinkSection)`
  ${screen.lg} {
    margin-left: auto;
  }

  ${screen.xxlg} {
    margin-left: 60px;
  }
`;

LinkSection.defaultProps = {
  title: null,
  children: null,
};

LinkSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
};

export { LinkSection, SocialLinkSection, Link, IconLink, IconGridWrapper };
